const palette = {
  // Primary
  primary: 'var(--sl-primary)',
  primaryH: 'var(--sl-primary-hover)',

  // Secondary
  secondary: 'var(--sl-secondary)',
  secondaryH: 'var(--sl-secondary-hover)',

  // Text
  defaultText: 'var(--sl-text-default)',

  // Links
  link: 'var(--sl-link)',

  // Borders
  border: 'var(--sl-border)',

  // Status
  success: 'var(--sl-success)',
  error: 'var(--sl-error)',
  errorBg: 'var(--sl-error-bg)',

  // Card
  cardTitle: 'var(--sl-card-title)',
  cardTitleBorder: 'var(--sl-card-title-border)',

  // Form
  fieldHint: 'var(--sl-field-hint)',

  // Sidebar
  sidebarBg: 'var(--sl-sidebar-bg)',
  sidebarBgSubtle: 'var(--sl-sidebar-bg-subtle)',
  sidebarBgHover: 'var(--sl-sidebar-bg-hover)',
  sidebarBgActive: 'var(--sl-sidebar-bg-active)',
  sidebarText: 'var(--sl-sidebar-text)',
  sidebarTextHover: 'var(--sl-sidebar-text-hover)',
  sidebarTextActive: 'var(--sl-sidebar-text-active)',
  sidebarBorder: 'var(--sl-sidebar-border)',
  sidebarAccent: 'var(--sl-sidebar-accent)',
  sidebarGlow: 'var(--sl-sidebar-glow)',

  // App header
  appHeaderBg: 'var(--sl-app-header-bg)',
  appHeaderBorder: 'var(--sl-app-header-border)',

  // Notifications
  notificationSuccessBg: 'var(--sl-notification-success-bg)',
  notificationWarningBg: 'var(--sl-notification-warning-bg)',
  notificationErrorBg: 'var(--sl-notification-error-bg)',
  notificationInfoBg: 'var(--sl-notification-info-bg)',

  // Toast
  toastWarningBg: 'var(--sl-toast-warning-bg)',

  // Dialogs
  dialogErrorHeaderBg: 'var(--sl-dialog-error-header-bg)',
  dialogBorder: 'var(--sl-dialog-border)',

  // Breadcrumbs
  breadcrumbLastItem: 'var(--sl-breadcrumb-last-item)',

  // Avatar
  avatarDefaultBg: 'var(--sl-avatar-default-bg)',
  avatarDefaultBorder: 'var(--sl-avatar-default-border)',
  avatarDefaultColor: 'var(--sl-avatar-default-color)',

  // Miscellaneous
  addAccountText: 'var(--sl-add-account-text)',
  filterIcon: 'var(--sl-filter-icon)',
  slateViewActionBg: 'var(--sl-slate-view-action-bg)',
  companyLogoBg: 'var(--sl-company-logo-bg)',

  // Warning
  infoWarningBg: 'var(--sl-info-warning-bg)',
  infoWarningColor: 'var(--sl-info-warning-color)',

  // Toggle
  switchTrue: 'var(--sl-switch-true)',
  switchFalse: 'var(--sl-switch-false)',

  // Brand
  brandOrange: 'var(--sl-brand-orange)',
  brandOrangeD: 'var(--sl-brand-orange-dark)',
  brandBlue: 'var(--sl-brand-blue)',
  brandBlueD: 'var(--sl-brand-blue-dark)',

  // Base
  white: 'var(--sl-white)',

  // Surfaces (theme-aware)
  bgSurface: 'var(--sl-bg-surface)',
  bgSurfaceRaised: 'var(--sl-bg-surface-raised)',
  bgPage: 'var(--sl-bg-page)',

  // Grey scale
  grey200: 'var(--sl-grey-200)',
  grey300: 'var(--sl-grey-300)',
  grey400: 'var(--sl-grey-400)',
  grey600: 'var(--sl-grey-600)',
  grey800: 'var(--sl-grey-800)',

  // Panel
  slatePaneBg: 'var(--sl-slate-pane-bg)',

  // Image preview
  imagePreviewBg: 'var(--sl-image-preview-bg)',
  imagePreviewBorder: 'var(--sl-image-preview-border)',
  imagePreviewLabel: 'var(--sl-image-preview-label)',

  // Table (legacy dark)
  tableHeaderBg: 'var(--sl-table-header-bg)',
  tableHeaderCellBg: 'var(--sl-table-header-cell-bg)',
  tableRowHover: 'var(--sl-table-row-hover)',
  tableRowSelected: 'var(--sl-table-row-selected)',
  tableRowSelectedBorder: 'var(--sl-table-row-selected-border)',
  tableRowSelectedFixed: 'var(--sl-table-row-selected-fixed)',

  // Table (light)
  tableHeaderBgLight: 'var(--sl-table-header-bg-light)',
  tableHeaderText: 'var(--sl-table-header-text)',
  tableRowWarm: 'var(--sl-table-row-warm)',
  tableRowWarmAlt: 'var(--sl-table-row-warm-alt)',
  tableBorderSubtle: 'var(--sl-table-border-subtle)',
  tableSelectionBg: 'var(--sl-table-selection-bg)',
  tableSelectionBorder: 'var(--sl-table-selection-border)',
};

export default palette;
